// @ts-nocheck

import { Dropdown } from 'antd'
import PropTypes from 'prop-types'
import type React from 'react'

/**
@description Renders an Antd Dropdown

https://ant.design/components/dropdown/

@param {node} children. All children components.
Rendered when the dropdown is opened.

@param {node} label. Label for dropdown.

@param {function} onOpenChange. Fires when the
dropdown is closed, either by clicking outside it
or by clicking on the label.

@param {string} placement. Positioning of
the dropdown relative to the label.

@param {string} trigger. The trigger for
the dropdown. E.g. click, hover.

@returns {function} AntdDropdown.
*/

export type AntdDropdownProps = {
  children?: React.ReactNode
  label?: React.ReactNode
  onOpenChange?: () => void
  placement?: string
  trigger?: string
}

export default function AntdDropdown(props: AntdDropdownProps) {
  const { children, label, onOpenChange, placement, trigger } = props

  return (
    <Dropdown
      overlay={children}
      onOpenChange={onOpenChange}
      placement={placement}
      trigger={trigger}
    >
      <div>{label}</div>
    </Dropdown>
  )
}

AntdDropdown.propTypes = {
  children: PropTypes.node,
  label: PropTypes.node,
  onOpenChange: PropTypes.func,
  placement: PropTypes.string,
  trigger: PropTypes.string
}
